import React, {Component} from "react";
import {TableCell, TableRow} from "@material-ui/core";
import {DateDisplay} from "core/Display";
import EditContractDialog from "./EditContractDialog";
import styled, {css} from "styled-components";
import { grey } from "@material-ui/core/colors";


const StyledTableRow = styled(TableRow)`
  ${props => !props.$isActive && css`
    background: ${grey[200]};
    td {
      color: ${grey[600]};
    }
  `}
`;


export default class ContractListItem extends Component {
  render() {
    const { item, listContext } = this.props;
    return (
      <StyledTableRow $isActive={item.is_active}>
        <TableCell>{item.is_active ? 'Да' : 'Нет'}</TableCell>
        <TableCell>{item.counterparty && item.counterparty.name}</TableCell>
        <TableCell>{item.carrier && item.carrier.name}</TableCell>
        <TableCell style={{whiteSpace: 'nowrap'}}>{item.number}</TableCell>
        <TableCell><DateDisplay value={item.date_start} /></TableCell>
        <TableCell>
          {item.automatic_prolongation ? '...' : <DateDisplay value={item.date_end} />}
        </TableCell>
        <TableCell>
          {item.exchanged_originals === true && 'Да'}
          {item.exchanged_originals === false && 'Нет'}
          {item.exchanged_originals === null && '-'}
        </TableCell>
        <TableCell>
          <EditContractDialog item={item} listContext={listContext} />
        </TableCell>
      </StyledTableRow>
    )
  }
}